import React from "react";
import { connect } from "react-redux";

import { HubContextMenu } from "../../components";
import { setIsOpenDialog } from "../../redux";

const MENU_ITEMS = [
  {
    id: "edit",
    label: "Edit Group (Editar Grupo)",
    icon: "Edit",
  },
  {
    id: "deleteRoute",
    label: "Delete Route (Borrar Ruta)",
    icon: "Trash2",
    color: "redMain",
  },
  {
    id: "deleteGroup",
    label: "Delete Group (Borrar Grupo)",
    icon: "Layers",
    color: "redError",
  },
];

const LaborSubRouteContextMenu = ({ item, _setIsOpenDialog = () => {} }) => {
  const onSelect = (sel) => {
    switch (sel?.id) {
      case "edit":
        _setIsOpenDialog("create-route-rework", item?.groupId);
        break;
      case "delete":
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"subroute-details"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: "0px" } }}
      HubIconProps={{ size: 14 }}
    />
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LaborSubRouteContextMenu);
